<aionz-generic-purchase-request-dialog
  [title]="'Sugestões de Produtos de Vendedores Parceiros'"
  [description]="
    'Encontramos ' + suggestions.length + ' produto(s) à venda por vendedores parceiros parecidos com os itens desta solicitação. Avalie cada sugestão para aprovar ou rejeitar.'
  "
  [declineButtonText]="'Fechar'"
  [showDeclineButton]="true"
  [showApproveButton]="false"
  (onDecline)="close()"
  (onCancel)="close()">
  <seed-card-table
    tableContent
    [scrollOnOverflow]="true">
    <seed-card-table-body>
      <table
        mat-table
        [dataSource]="sortedSuggestions">
        <ng-container matColumnDef="requestedProductTitle">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Produto pedido
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.requestedProductTitle }}
          </td>
        </ng-container>

        <ng-container matColumnDef="suggestedProductTitle">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Produto sugerido
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <div class="flex-row items-center gap-8">
              <aionz-kanban-chip-badge
                label="Vendedor Parceiro"
                icon="handshake"
                color="var(--color-info-default)"
                tooltip="Produto à venda por um vendedor parceiro"
                [compact]="true" />
              {{ row.suggestedProductTitle }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="supplierName">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Fornecedor
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.supplierName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Preço
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.price | currency: 'BRL' : 'symbol' : '1.2-2' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="similarityScore">
          <th
            mat-header-cell
            *matHeaderCellDef>
            <span
              matTooltip="Quanto dos termos do item pedido aparece na oferta do vendedor parceiro"
              tabindex="0">
              Aderência
            </span>
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ similarityPercentage(row) }}%
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Ações
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            <div class="actions-cell flex-row items-center gap-8">
              <button
                mat-icon-button
                type="button"
                class="approve-icon"
                [attr.aria-label]="'Aprovar sugestão de vendedor parceiro para ' + row.requestedProductTitle"
                (click)="onApprove(row)">
                <mat-icon>check</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                class="reject-icon"
                [attr.aria-label]="'Rejeitar sugestão de vendedor parceiro para ' + row.requestedProductTitle"
                (click)="onReject(row)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"></tr>

        <tr
          class="mat-row"
          *matNoDataRow>
          <td
            class="mat-cell text-center py-3"
            colspan="6">
            Nenhuma sugestão de vendedor parceiro encontrada!
          </td>
        </tr>
      </table>
    </seed-card-table-body>
  </seed-card-table>
</aionz-generic-purchase-request-dialog>
